'use strict'

import common from 'assets/themes/campings/js/page/common/index'

export default function (): void {
  const submitEl = document.getElementById('search_offers_search')
  const resultsEl = document.getElementById('results')
  const flexibleDateEl = document.getElementById('search_offers_flexibleDate')

  const submitForm = (): void => {
    if (!common.isMobile() && !common.isTablet()) {
      if (resultsEl) {
        resultsEl.dispatchEvent(new CustomEvent('loading.show'))
      }

      if (submitEl) {
        submitEl.click()
      }
    }
  }

  if (flexibleDateEl) {
    flexibleDateEl.addEventListener('click', submitForm)
  }
}
